<template>
  <div class="container">
    <div class="schedules">
      <div class="left-menu">
        <ul class="clearfix" style="position: fixed; left: 1rem; top: 1rem; width: 24%;">
          <template v-for="(item, index) in category">
            <li :key="index" class="active">{{item.label}}</li>
          </template>
        </ul>
      </div>
      <div class="no-content" style="margin-left: 4rem;">
        <p>暂无相关服务</p>
      </div>
      <div class="right-menu" style>
        <div class="h10"></div>
        <div class="service">
          <ul class="service-list clearfix">
            <li @click="openSheet(item.id)" v-for="(item, index) in goodsList" :key="index">
              <div class="img" :style="'background-image:url(' + item.firstPhoto + ')'"></div>
              <div class="text">
                <p class="name">{{item.proName}}</p>
                <p class="price">￥{{item.price}}</p>
              </div>
              <div class="btn">
                <p style="background-color: white;">
                  <i class="iconfont">&#xe70b;</i>
                  <i>0</i>
                </p>
                <p style="background-color: white;" @click.stop="addCart(item.id)">
                  <img
                    src="../../assets/add.svg"
                    alt=""
                    style="height: 2.4rem; width: 2.4rem !important;"
                  />
                </p>
                <p
                  style="border-radius: 5rem; background-color: rgb(21, 168, 146); font-size: 1.2rem; display: none;"
                >
                  选规格
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear-foot"></div>
    <section class="footer">
      <div class="shop">
        <i class="iconfont" style="font-size:2.5rem;">&#xe70b;</i>
        <i class="itxt">{{ goodsNum }}</i>
      </div>
      <a class="add">
        合计：
        <span class="money">￥{{goodsSum}}</span>
      </a>
      <a class="settle" @click="goPay">提交预定</a>
    </section>
    <!-- <div class>
      <div class="success">
        <p class="title">提交成功</p>
        <span class="text">
          您已成功预约
          <br />请在我的订单中查看预约反馈
        </span>
      </div>
    </div> -->

    <van-action-sheet v-model="show" title="服务介绍">
      <div>
        <div class="popBox">
          <div class="header">
            <div class="img" :style="'background-image:url(' + goodsInfo['firstPhoto'] + ')'"></div>
            <div class="text">
              <p class="name">{{goodsInfo['proName']}}</p>
              <p class="price">￥{{goodsInfo['price']}}</p>
            </div>
          </div>
          <div class="service">
            <p class="title">规格</p>
            <div class="btnList2 clearfix">
              <a class="active">{{$properties(goodsInfo,'subscribeSpecs','label')}}</a>
            </div>
          </div>
          <div class="service servicePop">
            <ul class="info-list">
              <li>
                <span style="color: rgb(50, 50, 50);">图片介绍</span>
              </li>
              <li>
                <ul class="img-list">
                  <li v-for="(item,index) in goodsInfo['gallery']" :key="index">
                    <div class="img" :style="'background-image:url(' + item + ')'"></div>
                  </li>
                </ul>
              </li>
              <!---->
              <li>
                <span style="color: rgb(50, 50, 50);">详细介绍</span>
              </li>
              <li style="color: rgb(153, 153, 153);">
                <p v-html="goodsInfo['proDetail']"></p>
              </li>
              <!---->
            </ul>
          </div>
          <div class="clear-foot"></div>
        </div>
        <div class="foot-bar">
          <div class="btn" style="width: 100%;" @click="addCart(goodsInfo['id'])">添加服务</div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'yudingfuwu',
  data() {
    return {
      proImg: require('../../assets/shop.jpg'),
      show: false,
      num: 0,
      selected: '',
      goodsSum: 0,
      goodsNum: 0,
      goodsCart: [],
      category: [],
      goodsList: [],
      goodsInfo: {},
      goodsTotal: 0,
    }
  },
  computed: {},
  created() {
    this.queryCategory()
    if(this.category.length>0) {
      this.select = this.category[0].value
      this.queryGoodsPage(this.select)
    }
  },
  methods: {
    goPay() {
      var goodsId = []
      for(var j=0; j<this.goodsCart.length; j++){
        goodsId.push(this.goodsCart[j]['id'])
      }
      if(goodsId.length>0){
        this.$router.push({ path: '/shop/ydfwcart',query:{goodsIds:goodsId.join(',')}})
      }
    },
    goCart(){
      this.$router.push({ path: '/shop/cart?channel=shop'})
    },
    addCart(id) {
      var existFlag = false
      for(var j=0; j<this.goodsCart.length; j++){
        if(id==this.goodsCart[j]['id']){
          existFlag = true
          break
        }
      }
      if(!existFlag){
        for(var i=0; i<this.goodsList.length;i++){ 
          if(id==this.goodsList[i]['id']){
            this.goodsCart.push(this.goodsList[i])
            break
          }
        }
      }
      this.calcCart()
    },
    calcCart(){
      var goodsSum = 0;
      var goodsNum = 0;
      for(var j=0; j<this.goodsCart.length; j++){
          goodsSum = goodsSum + this.goodsCart[j]['price']
          goodsNum = goodsNum + 1
      }
      this.goodsSum = goodsSum
      this.goodsNum = goodsNum
    },
    queryCategory(){
      var that = this
      this.category = []
      var goodsCategory = this.$store.getters.codelist['GOODS_SUBSCRIBE_TYPE']
      Object.keys(goodsCategory).forEach(function (key) {
          that.category.push({value:key, label: goodsCategory[key]})
      });
    },
    queryGoodsPage(category){
      var that = this
      this.$queryPage(
        'ProGoods',
        { channel: 'subscribe', subscribeType: category, sort:{orderNum:1}},
        ['id,proName,price,subscribeSpecs,firstPhoto,gallery,proDetail'],
        function(res) {
          that.$fill(that.goodsList, res['data'])
          that.goodsTotal = res['total']
        }
      )
    },
    openSheet(id){
      for(var i=0; i<this.goodsList.length;i++){
        if(id==this.goodsList[i]['id']){
          this.goodsInfo = this.goodsList[i]
        }
      }
      this.show = true
    },
    closeSheet(){

    }
  },
  watch: {},
}
</script>

<style>
.container {
  background-color: #f3f3f3;

  padding: 1rem;
  font-size: 1.6rem;
}

.schedules {
  width: 100%;
  height: calc(100% - 9rem);
  overflow: hidden;
  display: flex;
}
.schedules .left-menu {
  width: 9rem;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f6f6f6;
  text-align: center;
  color: #323232;
}

.schedules .left-menu,
.schedules .right-menu {
  font-size: 1.6rem;
  color: #fff;
  line-height: 2.2rem;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}

.schedules .left-menu > ul li.active {
  color: #fff;
  background-color: #15a892;
  font-size: 1.6rem;
}

.schedules .left-menu > ul li,
.schedules .right-menu > ul li {
  padding: 1.5rem 0;
}
.schedules .left-menu > ul li,
.schedules .right-menu > ul li {
  padding: 1.5rem 0;
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}

.no-content {
  display: none;
  width: 12rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.schedules .right-menu {
  flex: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
}

.schedules .left-menu,
.schedules .right-menu {
  font-size: 1.6rem;
  color: #fff;
  line-height: 2.2rem;
}
.h10 {
  width: 100%;
  height: 1rem;
}
.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.service ul.service-list li:last-child {
  border-bottom: 0;
}

.service ul.service-list li {
  min-height: 10rem;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.clear-foot {
  clear: both;
  height: 5rem;
}
.footer {
  background: #eee;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  background-color: #fff;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
}
.footer .shop {
  width: 3.6rem;
  margin: 0 3.5rem;
  position: relative;
}
.footer .shop img {
  width: 2rem;
  height: 2rem;
  margin-top: 1.7rem;
  display: inline-block;
}
.footer .shop .itxt {
  position: absolute;
  font-size: 1rem;
  top: 0.8rem;
  right: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  background: #15a892;
  color: #fff;
  border-radius: 50%;
}
.footer .add {
  background: #fff;
  width: 13.5rem;
  text-align: center;
}
.footer .money {
  color: #15a892;
}
.footer .settle {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
.service ul.service-list li .img {
  width: 8rem;
  height: 8rem;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}

.img {
  height: 6.6rem !important;
  width: 8.6rem !important;
}
.service ul.service-list li .text {
  width: 13rem;
}
.service ul.service-list li .text .name {
  font-size: 1.6rem;
  color: #323232;
  line-height: 2.2rem;
}

.service .name {
  font-size: 1.4rem;
  color: #999;
}

.name,
.price {
  padding-left: 1rem;
}
.service ul.service-list li .text .price {
  margin-top: 0.4rem;
  font-size: 1.4rem;
  color: #15a892;
  line-height: 2rem;
}

.service .price {
  font-size: 1.3rem;
  color: #15a892;
}

.name,
.price {
  padding-left: 1rem;
}
.service ul.service-list li .btn > p {
  width: 7rem;
  height: 3rem;
  line-height: 3rem;
  background: #15a892;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.service ul.service-list li .btn > p {
  width: 7rem;
  height: 3rem;
  line-height: 3rem;
  background: #15a892;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.service ul.service-list li .btn > p {
  width: 7rem;
  height: 3rem;
  line-height: 3rem;
  background: #15a892;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.schedules .left-menu > ul li {
  color: #323232;

  font-size: 1.6rem;
}
.schedules .left-menu > ul li.active {
  color: #fff;
  background-color: #15a892;
  font-size: 1.6rem;
}

.schedules .left-menu > ul li,
.schedules .right-menu > ul li {
  padding: 1.5rem 0;
}
.popBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.popBox .cancel {
  font-size: 1.8rem;
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: #999;
  line-height: 1.1rem;
}
.popBox .header {
  min-height: 10rem;
  padding: 1.8rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.popBox .header .img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.5rem;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.popBox .header .text {
  width: 13rem;
  margin-right: 1rem;
}
.popBox .header .text .name {
  font-size: 1.6rem;
  color: #323232;
  line-height: 2.2rem;
}
.popBox .header .text .price {
  margin-top: 1.6rem;
  font-size: 1.4rem;
  color: #15a892;
  line-height: 2rem;
}
.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.service .btnList2 a.active {
  color: #fff;
  background-color: #15a892;
}

.service .btnList2 a {
  width: calc(33.3% - 0.66rem);
  font-size: 1.4rem;
  text-align: center;
  height: 3.2rem;
  line-height: 3.2rem;
  float: left;
  border: 1px solid #eee;
  color: #999;
  margin-bottom: 1.5rem;
}
.popBox .servicePop {
  height: 20rem;
}

.servicePop {
  width: 100%;
  height: 28rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.service ul.info-list {
  padding-top: 1.5rem;
}
.service ul.info-list > li {
  width: 100%;
  color: #323232;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-bottom: 1.5rem;
  display: flex;
  justify-content: flex-start;
}
.service ul.info-list > li span {
  color: #999;
  width: 7.5rem;
  display: block;
  flex: none;
}
.service ul.img-list {
  width: 100%;
  margin-left: -0.5rem;
}
.popBox .service ul .img-list > li {
  margin: 0 0.5rem 0.5rem;
}

.service ul.img-list > li {
  width: calc(20% - 1rem);
  overflow: hidden;
  float: left;
  line-height: normal;
  margin: 0 0.5rem 1.5rem;
}

.service ul.img-list > li .img,
.service ul.img-list > li img {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.clear-foot {
  clear: both;
  height: 5rem;
}
.foot-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.foot-bar .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
}
</style>
